<template>
  <div class="data-level-step pt-32">
    <div class="data-level-step__container">
      <div class="data-level-step__headline mb-24">
        <div class="flex align-center">
          <img
            class="occupation-step__avatar w-48 h-48 radius-50 mr-8"
            :src="require('@images/avatars/avatar.png')"
            alt="Anatoli, the author of SQL Habit">

          <span
            class="h2"
            v-html="$options.filters.md('What\'s your current level of working with data?')" />
        </div>
      </div>

      <div class="data-level-step__levels">
        <SelectableCard
          v-for="level in availableLevels"
          class="data-level-step__level"
          v-bind:key="level"
          @selected="toggleLevel(level)"
          :value="level"
          :selected="selectedLevel === level"
          :emoji="$t(`levelEmoji.${level}`)"
          :name="$t(`levelName.${level}`)"
          :description="$t(`levelDescription.${level}`)" />
      </div>
    </div>
  </div>
</template>

<script>
import SelectableCard from "components/shared/selectable-card";

export default {
  components: {
    SelectableCard
  },
  data() {
    return {
      availableLevels: ["beginner", "intermediate", "advanced"],
      selectedLevel: null
    }
  },
  props: {
    dataLevel: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleLevel(level) {
      this.selectedLevel = level;

      this.$emit("toggle-data-level", this.selectedLevel);
    },
  },
  mounted() {
    this.selectedLevel = this.dataLevel;
  },
  i18n: {
    messages: {
      en: {
        levelEmoji: {
          beginner: ":seedling:",
          intermediate: ":wrench:",
          advanced: ":bar_chart:"
        },
        levelName: {
          beginner: "**GETTING STARTED**",
          intermediate: "**DATA TINKERER**",
          advanced: "**ADVANCED**"
        },
        levelDescription: {
          beginner: "I'm just starting with Data Analysis and SQL.",
          intermediate: "I can clone and adjust a dashboard query.",
          advanced: "I can build any BI dashboard on my own."
        }
      }
    }
  }
}
</script>

.<style lang="scss">
.data-level-step {
  &__levels {
    display: flex;
    flex-direction: column;
    max-width: $px720;
    gap: $px16;

    @include breakpoint($sm) {
      width: 100%;
      flex-direction: row;
    }
  }
}
</style>
